import React from 'react'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'

function UnsupportedBrowserModal() {
  return (
    <Modal
      visible
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      title="Navegador não suportado"
    >
      <div style={{ textAlign: 'center' }}>
        <ExclamationCircleOutlined
          style={{ fontSize: 40, color: '#faad14', marginBottom: 16 }}
        />
        <p style={{ fontSize: 16, marginBottom: 8 }}>
          O acesso pelo Microsoft Edge não é permitido.
        </p>
        <p style={{ fontSize: 16, marginBottom: 0 }}>
          Utilize o <strong>Google Chrome</strong> ou o{' '}
          <strong>Firefox</strong> para continuar.
        </p>
      </div>
    </Modal>
  )
}

export default UnsupportedBrowserModal
